import React, { useEffect } from "react";
import moment from "moment";
import { decoder, filterPayType, filterTree, filterOnAccount } from "../../../utils/decoder"
import { Button, Drawer, Form, Input, Select } from "antd";
import { useModel } from "../../../models";
import { debounce } from "lodash";

const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 6,
        span: 18,
    },
};

const AreaForm = () => {
    const [{ payTypeDict },] = useModel("cmDict");
    const [
        { selectedDocument, formData },
        { settle, setSelectedDocument, setPaymentDrawerVisible }
    ] = useModel("saleRo");
    const [form] = Form.useForm();


    useEffect(() => {
        const { payableAmount } = formData;
        const payDate = moment().format("YYYY-MM-DD")
        const {
            returnCode,
            createTime,
            customerCode,
            customerName,
            paidAmount = 0,
            paymentMethod
        } = selectedDocument;

        form.setFieldsValue({
            returnCode,
            createTime,
            customerCode,
            customerName,
            payedAmount: paidAmount,
            payableAmount,
            payType: paymentMethod,
            payDate,
        });
        /*form.setFieldsValue({returnCode: selectedDocument.returnCode});
        form.setFieldsValue({createTime: selectedDocument.createTime});
        form.setFieldsValue({customerCode: selectedDocument.customerCode});
        form.setFieldsValue({customerName: selectedDocument.customerName});
        form.setFieldsValue({payDate: moment().format("YYYY-MM-DD")});
        form.setFieldsValue({payableAmount});
        form.setFieldsValue({payedAmount: 0});*/

    }, []);


    const onFinish = debounce(() => {
        form.validateFields().then(data => {
            const { payType, payDesc } = data;
            settle({
                showMsg: true,
                data: {
                    id: selectedDocument.id,
                    payTypeCode: payType,
                    payDesc,
                }
            }).then(ret => {
                if (ret) {
                    setSelectedDocument({
                        ...selectedDocument,
                        paidAmount: selectedDocument.payableAmount,
                        paymentMethod: form.getFieldValue("payType")
                    });
                    setPaymentDrawerVisible(false)
                }
            });
        })
    }, 500);

    const onClose = () => {
        setPaymentDrawerVisible(false)
    }
    return (
        <Form {...layout} form={form} name="control-hooks"
            onFinish={onFinish}>
            <Form.Item name="returnCode" label="退货单号">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="createTime" label="制单日期">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="customerCode" label="客户编码">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="customerName" label="客户名称">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="payDate" label="结算日期">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="payableAmount" label="应付金额">
                <Input disabled={true} />
            </Form.Item>
            <Form.Item name="payedAmount" label="已付金额">
                <Input disabled={true} />
            </Form.Item>
            {/*<Form.Item name="payAmount" label="本次付款" rules={[{required: true, message: '请输入本次付款金额',}]}>
                <Input/>
            </Form.Item>*/}
            <Form.Item name="payType" label="支付方式" rules={[{ required: true, message: '请选择支付方式', }]}>
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择支付方式"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    // 张家口
                    options={filterOnAccount(payTypeDict)}
                // 公司潍柴
                // options={payTypeDict}
                />
            </Form.Item>
            <Form.Item name="payDesc" label="备注" rules={[{ required: false }]}>
                <Input.TextArea />
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button type="primary" htmlType="submit">
                    确定
                </Button>
                <Button htmlType="button" onClick={onClose} className="margin-left-8">
                    取消
                </Button>
            </Form.Item>
        </Form>
    );
}
export default function () {
    const [{ paymentDrawerVisible }, { setPaymentDrawerVisible }] = useModel("saleRo");
    return (
        <Drawer
            title="销售退货付款"
            placement="right"
            width={500}
            closable={true}
            onClose={() => {
                setPaymentDrawerVisible(false)
            }}
            visible={paymentDrawerVisible}
        >
            <AreaForm />
        </Drawer>
    )
}